// @todo: Find a way so that access tokens are not stored on localstorage.
import { Injectable } from "@angular/core";
import { ICache } from "@auth0/auth0-angular";

@Injectable({
  providedIn: "root",
})
export class AuthCacheService implements ICache {
  private readonly pId = "7a4990ae-040a-4432-a598-6e90d87f0d2d";
  private readonly prefix = `forms-${this.pId}`;

  get<T = unknown>(key: string): T | undefined {
    const item = localStorage.getItem(this.prefix + key);
    if (!item) {
      return undefined;
    }
    try {
      return JSON.parse(item) as T;
    } catch (error) {
      console.error("Failed to parse stored cache item", error);
      return undefined;
    }
  }

  set<T = unknown>(key: string, value: T): void {
    try {
      const serialized = JSON.stringify(value);
      localStorage.setItem(this.prefix + key, serialized);
    } catch (error) {
      console.error("Failed to store cache item", error);
    }
  }

  remove(key: string): void {
    localStorage.removeItem(this.prefix + key);
  }

  /**
   * Extracts the refresh token from the Auth0 cache.
   */
  getRefreshToken(): string | null {
    const auth0KeyPattern = "@@auth0spajs@@";

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key?.startsWith(this.prefix + auth0KeyPattern)) {
        try {
          const item = localStorage.getItem(key);
          if (item) {
            const parsed = JSON.parse(item) as { body?: { refresh_token?: string } };
            if (parsed?.body?.refresh_token) {
              return parsed.body.refresh_token;
            }
          }
        } catch {
          continue;
        }
      }
    }
    return null;
  }
}
